module.exports = __webpack_public_path__ + "static/media/dis_zh.84603676.png";